import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

const FORM_SUBMIT_ADDR = 'https://readdy.ai/api/form/d9otgb0senbnioleslk0';

const testimonials = [
  {
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20male%20character%20portrait%2C%20friendly%20smile%2C%20casual%20modern%20style%2C%20clean%20simple%20background%2C%20soft%20warm%20lighting%2C%20professional%20digital%20illustration%2C%20pleasant%20expression&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '韩漫漫画网站真的是我每天必刷的平台！画质清晰、加载速度快，最重要的是全部免费正版。追了《暗影之王》和《逆天邪神》两部，更新稳定，体验超棒！',
    rating: 5,
  },
  {
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20female%20character%20portrait%2C%20bright%20smile%2C%20cute%20casual%20style%2C%20clean%20simple%20background%2C%20soft%20warm%20lighting%2C%20professional%20digital%20illustration%2C%20cheerful%20expression&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '作为韩漫资深读者，真心推荐这个平台！分类很全，浪漫爱情和BL向的作品质量特别高。最喜欢《花之契约》，画风精美到每一帧都想截图当壁纸！',
    rating: 5,
  },
  {
    name: '上班族李先生',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20male%20office%20worker%20portrait%2C%20gentle%20smile%2C%20smart%20casual%20style%2C%20clean%20simple%20background%2C%20soft%20warm%20lighting%2C%20professional%20digital%20illustration%2C%20kind%20expression&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '通勤路上的最佳伴侣！自从发现了韩漫漫画网站，每天地铁上都要刷几话。《办公室罗曼史》简直是为我们打工人量身定做的，搞笑又治愈。',
    rating: 4,
  },
  {
    name: '大学生小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20female%20student%20portrait%2C%20bright%20eyes%2C%20casual%20student%20style%2C%20clean%20simple%20background%2C%20soft%20warm%20lighting%2C%20professional%20digital%20illustration%2C%20youthful%20expression&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '室友推荐的这个网站，结果我们整个宿舍都在追！《魔法学院日常》和《心跳加速》太甜了，每天讨论剧情成了我们的日常。界面清爽无广告，体验一流。',
    rating: 5,
  },
];

const milestones = [
  { year: '2020', title: '平台成立', description: '韩漫漫画网站正式上线，致力于为中国读者提供高质量的韩国漫画阅读体验。' },
  { year: '2021', title: '正版合作', description: '与韩国多家知名漫画出版社达成正版授权合作，确保所有漫画资源均为正版内容。' },
  { year: '2022', title: '百万用户', description: '平台注册用户突破百万，成为国内领先的韩国漫画在线阅读平台之一。' },
  { year: '2023', title: '内容扩容', description: '漫画作品数量突破5000部，涵盖浪漫、奇幻、动作、悬疑等全品类韩国漫画。' },
  { year: '2024', title: '体验升级', description: '全面升级阅读体验，高清画质、极速加载、智能推荐，让阅读更流畅更愉悦。' },
  { year: '2025', title: '千万读者', description: '累计服务超过千万读者，日活跃用户突破百万，成为韩漫爱好者的首选平台。' },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }

    setFormStatus('submitting');
    setFormError('');

    try {
      const formData = new FormData(form);
      const response = await fetch(FORM_SUBMIT_ADDR, {
        method: 'POST',
        body: formData,
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        setFormStatus('error');
        setFormError(parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试');
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查网络后重试');
    }
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 韩漫漫画网站',
    description: '了解韩漫漫画网站的品牌故事、发展历程和联系方式。海量正版韩国漫画在线阅读平台。',
    url: 'https://www.manhwa-reader.com/about',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <div className="px-4 md:px-6 py-8">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]} />

            <section className="mt-6 mb-14">
              <div className="text-center max-w-3xl mx-auto mb-12">
                <h1 className="text-2xl md:text-4xl font-heading text-foreground-800 mb-4">关于韩漫漫画网站</h1>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                  韩漫漫画网站成立于2020年，是国内领先的韩国漫画在线阅读平台。我们与韩国多家知名漫画出版社建立正版合作关系，为中文读者提供海量优质的韩国漫画作品。从浪漫爱情到热血动作，从奇幻冒险到悬疑惊悚，我们致力于让每一位读者都能在这里找到心仪的漫画。
                </p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-14">
                <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="text-3xl font-bold text-primary-500 mb-1">10,000+</div>
                  <p className="text-sm text-foreground-500">正版漫画</p>
                </div>
                <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="text-3xl font-bold text-accent-500 mb-1">500万+</div>
                  <p className="text-sm text-foreground-500">注册用户</p>
                </div>
                <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="text-3xl font-bold text-primary-500 mb-1">8大</div>
                  <p className="text-sm text-foreground-500">漫画分类</p>
                </div>
                <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="text-3xl font-bold text-accent-500 mb-1">99.9%</div>
                  <p className="text-sm text-foreground-500">正版率</p>
                </div>
              </div>
            </section>

            <section className="mb-14">
              <h2 className="text-2xl font-heading text-foreground-800 mb-8 text-center">发展历程</h2>
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-secondary-200 md:-translate-x-px"></div>
                <div className="space-y-8">
                  {milestones.map((m, index) => (
                    <div key={m.year} className={`flex flex-col md:flex-row gap-4 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                      <div className="md:w-1/2 pl-10 md:pl-0">
                        <div className={`p-5 rounded-xl bg-background-50 border border-background-200/70 ${index % 2 !== 0 ? 'md:mr-auto md:ml-0' : 'md:ml-auto md:mr-0'} md:max-w-sm`}>
                          <span className="inline-block px-3 py-1 text-xs font-bold bg-primary-100 text-primary-700 rounded-full mb-2">{m.year}</span>
                          <h3 className="text-base font-semibold text-foreground-800 mb-1">{m.title}</h3>
                          <p className="text-sm text-foreground-500">{m.description}</p>
                        </div>
                      </div>
                      <div className="hidden md:block md:w-1/2"></div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="mb-14">
              <h2 className="text-2xl font-heading text-foreground-800 mb-8 text-center">读者口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {testimonials.map((t, i) => (
                  <div key={i} className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                        <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" loading="lazy" />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                        <div className="flex items-center gap-0.5">
                          {Array.from({ length: 5 }).map((_, j) => (
                            <i key={j} className={`text-xs ${j < t.rating ? 'ri-star-fill text-accent-400' : 'ri-star-line text-foreground-300'}`}></i>
                          ))}
                        </div>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-14">
              <h2 className="text-2xl font-heading text-foreground-800 mb-8 text-center">联系我们</h2>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                  <h3 className="text-lg font-semibold text-foreground-800 mb-4">联系方式</h3>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                        <i className="ri-mail-line"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">电子邮箱</p>
                        <p className="text-sm text-foreground-500">support@manhwa-reader.com</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 flex-shrink-0">
                        <i className="ri-customer-service-line"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">在线客服</p>
                        <p className="text-sm text-foreground-500">工作日 9:00 - 21:00</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 flex-shrink-0">
                        <i className="ri-map-pin-line"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">公司地址</p>
                        <p className="text-sm text-foreground-500">北京市朝阳区望京科技园区</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                  <h3 className="text-lg font-semibold text-foreground-800 mb-4">意见反馈</h3>
                  <form data-readdy-form onSubmit={handleSubmit} action={FORM_SUBMIT_ADDR} method="POST" className="space-y-4">
                    <input
                      type="text"
                      name="website_alt"
                      className="hp-field"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">反馈内容</label>
                      <textarea
                        id="contact-message"
                        name="message"
                        required
                        maxLength={500}
                        rows={4}
                        className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                        placeholder="请告诉我们您的想法或建议（最多500字）"
                      ></textarea>
                    </div>
                    <button
                      type="submit"
                      disabled={formStatus === 'submitting'}
                      className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all duration-200 disabled:opacity-50 cursor-pointer whitespace-nowrap"
                    >
                      {formStatus === 'submitting' ? '提交中...' : '提交反馈'}
                    </button>
                    {formStatus === 'success' && (
                      <p className="text-sm text-green-600 text-center">感谢您的反馈，我们会尽快回复！</p>
                    )}
                    {formStatus === 'error' && (
                      <p className="text-sm text-red-500 text-center">{formError}</p>
                    )}
                  </form>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}